import $ from 'jquery';
import "magnific-popup";
import VideoPlayer from '../shared/videoPlayer';
import GoogleMapsApi from '../shared/GoogleMapsApi';
import Handlebars from "handlebars";

import Template from './popupTemplate.hbs'

export default class BranchPage {

    constructor() {

        this.selectors = {
            seeMoreButton: '#see_more',
            startNow: '[data-popup-btn]',
            getStarted: '#navGetStarted',
            branchEmployees: '.branch-member'
        };

        this.videoPlayer = new VideoPlayer();

        this.mapContainer = document.getElementById('map');
        this.initGoogleMapsScript();
    
        
    }

    init() {

        const geocoder = new google.maps.Geocoder();
        geocoder.geocode({ 'address': this.mapContainer.getAttribute('data-address') }, (results, status) => {
            if (status === google.maps.GeocoderStatus.OK) {
                if (status !== google.maps.GeocoderStatus.ZERO_RESULTS) {

                    this.map = new google.maps.Map(this.mapContainer, {
                        center: results[0].geometry.location,
                        zoom: 12,
                        disableDefaultUI: true,
                        zoomControl: true,
                        //addressControl: false,
                        //enableCloseButton: false,
                        //zoomControl: false,
                        //fullScreenControl: false
                    });
                 
                    var marker = new google.maps.Marker({
                        position: results[0].geometry.location,
                        map: this.map,
                        title: document.getElementById('branch_name').textContent
                    });

                } else {
                    //alert("No results found");
                }
            } else {
                //alert("Geocode was not successful for the following reason: " + status);
            }
        });

        this.bind();
    }

    bind() {

        $(this.selectors.seeMoreButton).on('click', (e) => {
            $(this.selectors.branchEmployees).removeClass('d-none');
            $(e.target).addClass('d-none');
        });
        $(this.selectors.startNow).on('click', (e) => {
            e.preventDefault()
            this.openPopup()
        });
        $(this.selectors.getStarted).on('click', (e) => {
            e.preventDefault()
            this.openPopup()
        });
        $('body').on({
            'click': (e) => {
                e.preventDefault();
                const el = $(e.currentTarget),
                    modal = el.closest('[data-popup]'),
                    select = modal.find('select').val()
                    if(!select.length){
                        modal.find('[data-error]').removeClass('d-none')
                    } else {
                        modal.find('[data-error]').addClass('d-none')
                        window.location.replace(select);
                    }
            }
        },'[data-reload-loan]')
    }
    openPopup() {
        if($('[data-link-url]').length){
            let data = [];
            $.each($('[data-link-url] option'), (i,e) => {
                let items = {}
                items.url = $(e).attr('value')
                items.text = $(e).text()
                data.push(items)
            })
            this.renderPopup({'items':data}).then((html) => {
                $.magnificPopup.open({
                    items: html,
                    closeBtnInside:true,
                    type: 'inline',
            
                    callbacks: {
                        markupParse: function(template, values, item) {
                            template.append(item.data)
                        }
                    },
                    inline: {
                        markup: '<div class="white-popup apply-popup">' +
                        '<div class="mfp-close"></div>' +
                        "</div>"
                    },
            
                    removalDelay: 500,
                    midClick: true
                });
            })
        }
      
    
    }
    renderPopup(param){
        return new Promise((resolve, reject) => {
            let source = Template()
            let template = Handlebars.compile(source);
            let html = template(param)
        
          
            resolve(html)
        })
    }
    initGoogleMapsScript() {
        const gmapApi = new GoogleMapsApi();

        gmapApi.load().then(() => {
            this.init();
        });
    }

   
}